import { Spinner } from "@chakra-ui/react";
import { Button } from "newui/components/Button";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

interface StepNavigationProps {
	currentStep: number;
	currentStepEnabled: boolean;
	isSubmitting?: boolean;
	nextLabel?: string;
	readOnly?: boolean;
	totalSteps: number;
	onBack: () => void;
	onComplete: () => void;
	onNext: () => void;
}

export const StepNavigation: React.FC<StepNavigationProps> = ({
	currentStep,
	totalSteps,
	currentStepEnabled,
	isSubmitting = false,
	nextLabel,
	readOnly = false,
	onBack,
	onNext,
	onComplete,
}) => {
	const isFirstStep = currentStep === 0;
	const isLastStep = currentStep === totalSteps - 1;

	return (
		<div className="flex items-center justify-between mt-6 pt-4 border-t border-gray-200">
			<div>
				{!isFirstStep && (
					<Button
						btntype="secondary"
						onClick={onBack}
						type="button"
					>
						<FiChevronLeft className="mr-1" />
						Back
					</Button>
				)}
			</div>
			<div>
				{!readOnly && (
					isLastStep ? (
						<Button
							btntype="primary"
							onClick={onComplete}
							disabled={!currentStepEnabled || isSubmitting}
							type="button"
						>
							{isSubmitting ? (
								<>
									<Spinner size="sm" className="mr-2" />
									Submitting...
								</>
							) : (
								"Submit"
							)}
						</Button>
					) : (
						<Button
							btntype="primary"
							onClick={onNext}
							disabled={!currentStepEnabled}
							type="button"
						>
							{nextLabel ?? "Next"}
							{!nextLabel && <FiChevronRight className="ml-1" />}
						</Button>
					)
				)}
			</div>
		</div>
	);
};
